import { signOutAction } from "../app/actions";
import { store } from "../index"

export default (url, options = { method: "GET", headers: {}}) => {
    return fetch(url, 
        {
            ...options, 
            headers: {
                ...options.headers,
                Accept: "application/json, text/plain, */*"
            }
        }
    ).then((res) => {
        if(res.status >= 400 && res.status < 500) {

            return new Promise( (resolve, reject) => {
                res.json().then(body => {
                    if(body.autherror === true || (body.message === "Unauthenticated.")) {
                        store.dispatch(signOutAction())
                        reject()
                    }

                    resolve(body)
                })
            })
        }

        return res.json()
    })
}